import React from "react";
import { Wheat, Milk, Egg, Bean, Nut, AlertTriangle } from "lucide-react";
import { useLang, ALLERGENS } from "@/i18n";

const ICONS = { Wheat, Milk, Egg, Bean, Nut };

const STYLES = {
  gluten: "bg-amber-100 text-amber-900 border-amber-300",
  lait: "bg-sky-100 text-sky-900 border-sky-300",
  oeufs: "bg-yellow-100 text-yellow-900 border-yellow-300",
  soja: "bg-emerald-100 text-emerald-900 border-emerald-300",
  fruits_a_coque: "bg-orange-100 text-orange-900 border-orange-300",
};

export function AllergenBadge({ keyName, size = "md" }) {
  const { lang } = useLang();
  const meta = ALLERGENS[keyName];
  if (!meta) return null;
  const Icon = ICONS[meta.icon] || AlertTriangle;
  const label = meta[lang] || meta.fr;
  const pad = size === "lg" ? "px-3.5 py-2 text-sm" : "px-3 py-1.5 text-xs";
  const iconSize = size === "lg" ? 18 : 15;
  return (
    <span
      data-testid={`allergen-${keyName}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-bold ${STYLES[keyName] || "bg-zinc-100 text-zinc-900 border-zinc-300"} ${pad}`}
    >
      <Icon size={iconSize} strokeWidth={2.4} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
